import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"width":"400px","height":"332px"} }
const _hoisted_2 = { class: "dismiss posSt fr" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "mc",
  style: {"padding":"15px 10px"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", { class: "fs20 ls1 mc centered fw600 mt15" }, "課金リクエスト", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 0,
  src: "/images/service/step_3_payment.png",
  class: "mc w100 centered"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" ご利用いただきましていただきありがとうございます。 "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("送信いただきましたら、ご担当者よりご連絡いたします。 "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_19 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "閉じる", -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 whiteColor fw600" }, "リクエストを送信", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _createElementVNode("img", {
        src: _ctx.$getAssetImageUrl(`/assets/popUp/dismiss.png`),
        width: "33",
        height: "33"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _hoisted_6,
      (_ctx.type != `upgrade`)
        ? (_openBlock(), _createElementBlock("img", _hoisted_7))
        : _createCommentVNode("", true),
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11,
      _hoisted_12,
      _createVNode(_component_TextareaTag, {
        placeholder: "ご要望やお問い合わせしたい内容などありましたらご入力ください。",
        class: "fl fs14 roundForm mw100",
        value: _ctx.requestValue,
        onInputValue: _ctx.inputRequest
      }, null, 8, ["value", "onInputValue"]),
      _hoisted_13,
      _hoisted_14,
      _hoisted_15,
      _hoisted_16,
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
          }, _hoisted_21)
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("section", {
            class: "w100 greenBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.request && _ctx.request(...args)))
          }, _hoisted_24)
        ])
      ]),
      _hoisted_25,
      _hoisted_26
    ])
  ]))
}